import { getAppStoreURL } from '@hopin-team/dashboard-constants';

export const getAppStoreWebUrl = ({ organizationId, eventAreaParameter }) => {
  const organizationParameter = organizationId ? `/org/${organizationId}` : '';
  return `${getAppStoreURL()}${organizationParameter}${eventAreaParameter}`;
};
